// extracted by mini-css-extract-plugin
export default {"product-item-style":"CustomSelectProductCategory_product-item-style__ERHoM","selected":"CustomSelectProductCategory_selected__74Ij2"};